<template>
  <div class="flex justify-end">
    <div v-if="content.input" class="text-lg mr-2">
      <div class="bubble-buttom">
        {{ content.input }}
      </div>
    </div>
    <div class="inline w-11 h-11 -mr-1">
      <img v-if="content.input" class="h-full w-full" src="./head.svg" alt="头像" />
    </div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class TextInput extends Vue {
  @Prop({ type: Object }) content!: Content;
}
</script>

<style scoped>
.bubble-buttom {
  @apply relative my-2 p-3 rounded-md;
  background-color: rgba(243, 244, 246, 1);
}
</style>
